module.exports = __webpack_public_path__ + "img/product_36.85514fb.svg";